// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainBannerImage_simple_wrapper__2YQGf"};